<template>
  <Modal v-model="visible" title="请选择需要结算的数据" width="1400" :mask-closable="false" :footer-hide="true" :fullscreen="true">
    <div class="search-container">
      <div class="search-box" :class="{ close: !searchMore }">
        <div class="input-item">
          <span class="label">推荐人机构</span>
          <selectTree type="4" v-model="formData.orgIds" @change="changeOrg" ref="selectTree" :selectAll="false" :maxTagCount="1" :multiple="true"></selectTree>
        </div>

        <div class="input-item">
          <span class="label">推荐人团队</span>
          <Select v-model="formData.recommendGroupIds" multiple clearable filterable :max-tag-count="1" transfer>
            <Option v-for="(item, index) in groupList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>

        <div class="input-item">
          <span class="label">推荐人</span>
          <Select placeholder="请选择" v-model="formData.recommendId" clearable filterable transfer>
            <Option v-for="(item, i) in userList" :key="i" :value="item.id">
              <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
              {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
            </Option>
          </Select>
        </div>
      </div>
      <div class="btn-item btn-box">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
      </div>
    </div>

    <!-- 工具栏 -->
    <div class="tools-box">
      <div class="left-box">
        <Checkbox v-model="isAll" @on-change="selectAll" :disabled="tableData.length ? false : true">全部</Checkbox>
      </div>
      <div class="right-box">
        <span class="text"
          >已选择<span>{{ isAll ? total : selectArr.length }}</span
          >条，共<span>{{ total }}</span
          >条数据</span
        >
      </div>
    </div>

    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange">
        <template slot-scope="{ row }" slot="recommendname_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.recommendWorkingState == 0, orange: row.isSus == 1 }"></i>
              <span class="user-name">{{ row.recommendStaffNo }}</span>
              <span v-if="row.recommendStaffNo">/</span>
              <span class="user-name">{{ row.recommendName }}</span>
            </div>
          </div>
        </template>

        <!-- 推荐人手机号 -->
        <template slot-scope="{ row }" slot="mobile3">
          <span class="text" v-if="row.eyeShow">{{ row.mobile }}</span>
          <span class="text" v-else>{{ row.recommendMobile }}</span>
          <span v-if="$units.pointAction('offline_81_4_0_0')">
            <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow" @click="openEye(row.recommendId, row)"></i>
            <i class="iconfont iconyincang eye-icon" v-else-if="!row.eyeShow" @click="openEye(row.recommendId, row)"></i>
          </span>
        </template>

        <div slot-scope="{ row, index }" slot="beRecommendNum">
          <Poptip :placement="index == 0 ? 'bottom' : 'left'" width="700" transfer>
            <span style="cursor: pointer" class="table-btn">{{ row.beRecommendedNum }}</span>
            <div class="api" slot="content">
              <Table :columns="columns2" :data="row.beRecommendedList">
                <template slot-scope="{ row }" slot="berecommendname_staffNo">
                  <div class="name-status">
                    <div class="user-box">
                      <i
                        class="dian"
                        :class="{ red: row.beRecommendedWorkingState == 0, orange: row.beRecommendedIsSus == 1 }"
                        v-if="row.beRecommendedName"
                      ></i>
                      <span class="user-name">{{ row.beRecommendStaffNo }}</span>
                      <span v-if="row.beRecommendStaffNo">/</span>
                      <span class="user-name">{{ row.beRecommendedName }}</span>
                    </div>
                  </div>
                </template>

                <!-- 被推荐人手机号 -->
                <template slot-scope="{ row }" slot="beMobile3">
                  <span class="text" v-if="row.eyeShow">{{ row.mobile }}</span>
                  <span class="text" v-else>{{ row.beRecommendedMobile }}</span>
                  <span v-if="$units.pointAction('offline_81_4_0_0')">
                    <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow" @click="openEye(row.beRecommendedId, row)"></i>
                    <i class="iconfont iconyincang eye-icon" v-else-if="!row.eyeShow" @click="openEye(row.beRecommendedId, row)"></i>
                  </span>
                </template>
              </Table>
            </div>
          </Poptip>
        </div>
      </Table>
    </div>
    <Page
      :total="total"
      :current.sync="pageNum"
      :page-size="pageSize"
      show-total
      @on-change="getList"
      style="text-align: center; margin-top: 20px; margin-bottom: 50px"
    />

    <div class="footer-btn">
      <Button type="primary" @click="ok" :loading="loading">加入结算</Button>
      <Button @click="visible = false">取消</Button>
    </div>
  </Modal>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';

export default {
  components: { selectTree },
  mixins: [pageTool, common],
  props: ['reportId'],
  data() {
    return {
      visible: false,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '关联活动',
          align: 'center',
          key: 'activityName',
          minWidth: 250
        },
        {
          title: '奖励类型',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let rewardType = params.row.rewardType;
            if (rewardType == 1) {
              return <span>加费</span>;
            } else if (rewardType == 2) {
              return <span>实物</span>;
            } else {
              return <span>现金</span>;
            }
          }
        },
        {
          title: '奖励',
          align: 'center',
          key: 'rewardAmount',
          minWidth: 120
        },
        {
          title: '推荐人',
          align: 'center',
          minWidth: 250,
          slot: 'recommendname_staffNo'
        },
        {
          title: '被推荐人数量',
          align: 'center',
          minWidth: 130,
          slot: 'beRecommendNum'
        },
        {
          title: '推荐人手机号',
          align: 'center',
          minWidth: 150,
          key: 'recommendMobile',
          slot: 'mobile3'
        },
        {
          title: '推荐人所属团队',
          align: 'center',
          key: 'recommendGroupName',
          minWidth: 150
        },
        {
          title: '推荐人所属机构',
          align: 'center',
          key: 'recommendOrgName',
          minWidth: 150
        }
      ],
      columns2: [
        {
          title: '保单号',
          minWidth: 200,
          align: 'center',
          key: 'policyNo'
        },
        {
          title: '被推荐人',
          minWidth: 200,
          align: 'center',
          slot: 'berecommendname_staffNo'
        },
        {
          title: '被推荐人手机号',
          key: 'beRecommendedMobile',
          minWidth: 150,
          align: 'center',
          slot: 'beMobile3'
        },
        {
          title: '签约状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let recommendType = params.row.recommendType;
            let beRecommendedWorkingState = params.row.beRecommendedWorkingState;
            let beRecommendedIsSus = params.row.beRecommendedIsSus;
            if(recommendType == 1 && beRecommendedWorkingState != '0' && beRecommendedIsSus != 1) {
              return <span>注册</span>;
            } else if (recommendType == 2 && beRecommendedWorkingState != '0' && beRecommendedIsSus != 1) {
              return <span>入职</span>;
            }else if (beRecommendedWorkingState == '0') {
              return <span>离职</span>;
            }else if (beRecommendedIsSus == '1') {
              return <span>停职</span>;
            }
          }
        }
      ],
      loading: false,
      date: [],
      formData: {},
      userList: [], //业务员
      total: null,
      activityId: '',
      tableData: [],
      isAll: false, //全部产品
      selectArr: [], //表格选择的数据
      loading: false,
      activityName: null,
      selectOrgIds: [],
      groupList: []
    };
  },
  methods: {
    async open(activityId, orgIds, activityName) {
      this.visible = true;
      await this.getGroupList(orgIds);
      this.$set(this, 'selectOrgIds', orgIds);
      this.$set(this.formData, 'orgIds', orgIds);
      this.$nextTick(() => {
        this.$refs.selectTree && this.$refs.selectTree.openChange(true);       
      });
      this.isAll = false;
      this.activityId = activityId;
      this.selectArr = [];
      this.date = [];
      this.activityName = activityName;
      this.getUserList(orgIds);
      this.searchAjax();
    },
    // 查询
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 重置
    resetSearch() {
      this.formData = {};
      this.date = [];
      this.formData.orgIds = this.selectOrgIds;
      this.searchAjax();
    },
    changeTimeNull(value, key) {
      this.formData[key] = '';
    },
    parameter() {
      let data = JSON.parse(JSON.stringify(this.formData));
      if (!data.orgIds.length) {
        data.orgIds = this.selectOrgIds;
      }
      return data;
    },
    // 获取列表
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/merchantActivity/queryNeedSettlementPolicy',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          recommendOrgIds: this.formData.orgIds,
          ...this.parameter(),
          activityId: this.activityId
        }
      })
        .then(res => {
          res.data.forEach(item => {
            item.activityName = this.activityName;
            item.key = item.recommendId;
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.key); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.key); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.key) && !selectIds.includes(item.key)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.key);
        } else if (!ids.includes(item.key) && selectIds.includes(item.key)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.key), 1);
          selectIds.splice(selectIds.indexOf(item.key), 1);
        }
      });
    },
    ok() {
      if (!this.isAll && !this.selectArr.length) {
        this.$notice.alert('请至少选择一条数据');
        return;
      }
      let params = {};
      if (this.isAll) {
        params = {
          reportId: this.reportId,
          isAll: 1,
          merchantActivityRecommendVOS: this.selectArr,
          merchantActivityRecommendQuery: {
            recommendOrgIds: this.formData.orgIds,
            ...this.parameter(),
            activityId: this.activityId
          }
        };
      } else {
        params = {
          reportId: this.reportId,
          isAll: 0,
          merchantActivityRecommendVOS: this.selectArr
        };
      }
      if (this.loading) return;
      this.loading = true;
      this.$http({
        url: '/buz/userSettlementData/saveData',
        type: 'POST',
        data: params
      })
        .then(res => {
          this.visible = false;
          this.$notice.success('加入结算成功');
          this.$emit('success');
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 获取当前机构业务员
    getUserList(orgIds = this.formData.orgIds) {
      this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: {
          orgaList: orgIds
        }
      }).then(res => {
        this.userList = res.data;
      });
    },
    // 获取当前团队
    getGroupList(orgIds = this.formData.orgIds) {
      this.$http({
        url: '/buz/organizationGroup/read/list',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999,
          organIds: orgIds
        }
      }).then(res => {
        this.groupList = res.data;
      });
    },
    changeOrg(data) {
      if (!data.length) {
        this.getUserList(this.selectOrgIds);
      } else {
        this.getUserList(data);
      }
    },
    // 解密
    openEye(id, row) {
      if (!row.eyeShow) {
        this.descrypt(
          {
            query: id,
            operationFunction: 47,
            operationType: 2
          },
          row,
          'mobile',
          'offline_81_4_0_0'
        ).then(() => {
          this.$set(row, 'eyeShow', true);
        });
      } else {
        this.$set(row, 'eyeShow', false);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.search-container {
  margin-bottom: 20px;
  position: relative;
  .search-box {
    height: 62px !important;
    margin-top: 20px;
    /deep/.select-two .ivu-select {
      width: 115px !important;
      .ivu-select-selection {
        border-right: 1px solid #dcdee2 !important;
      }
    }
  }
  .btn-box {
    position: absolute;
    bottom: 13px !important;
    right: -10px;
  }
  .dian {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #35bf3f;
    border-radius: 50%;
    margin-right: 4px;
    vertical-align: top;
    transform: translateY(7px);
    &.red {
      background: #e3461f;
    }
    &.orange {
      background: #ff9900 !important;
    }
  }
}
/deep/ .ivu-icon-ios-close {
  color: #3c464f !important;
}
/deep/.ivu-modal-close {
  top: 0px;
  font-size: 30px;
}
/deep/.ivu-modal-header {
  height: 45px;
  padding-left: 20px;
}
/deep/.ivu-modal-header-inner {
  font-size: 16px;
}
.footer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-btn {
    min-width: 100px;
    margin-right: 10px;
  }
}
</style>
